export default __webpack_public_path__ + "static/media/qana-project-4.5b07c9b3.jpg";